export default __webpack_public_path__ + "static/media/micromobility.5ce6733d.svg";